import React from "react";
import Navbar from "../components/LandingPageNew/Navbar";
import HeroSection from "../components/WebDesign/HeroSection";
import Offers from "../components/WebDesign/Offers";
import Principle from "../components/WebDesign/Principle";
import WhySeo from "../components/WebDesign/WhySeo";
import Projects from "../components/WebDesign/Projects";
import FreeConsultation from "../components/WebDesign/FreeConsultation";
import Attention from "../components/WebDesign/Attention";
import SEO from "../components/Shared/SEO";
import icon1 from "../Images/img/Component 16-18.png";
import icon2 from "../Images/img/Component 16-19.png";
import icon3 from "../Images/img/Component 16-20.png";
import icon4 from "../Images/img/Component 16-11.png";
import Footer from '../components/LandingPageNew/Footer';
import WhoItsForCards from '../components/WebDesign/WhoItsForCards';
import Hook from "../components/WebDesign/Hook";
import Portfolio from "../components/Shared/Portfolio";
const WebDesign = () => {
  const cardData = [
  {
    icon: icon1,
    step: "01",
    heading: "Schnelle Ladezeiten ",
    description: "Schnelle Ladezeiten entscheiden darüber, ob ein Kunde auf Ihrer Seite bleibt oder abspringt. Wir sorgen dafür, dass Ihre Webseite stets gut performt.",
  },
  {
    icon: icon2,
    step: "02",
    heading: "Conversion-Optimierung",
    description: "Durch klare Nutzerführung, psychologisch wirksame Call-to-Actions und optimierte Seitenstrukturen verwandeln wir Besucher in Kunden.",
  },
  {
    icon: icon3,
    step: "03",
    heading: "Responsive Design",
    description: "Wir entwickeln und gestalten deine Webseite für die optimale Nutzung auf allen Endgeräten. In Deutschland liegt der Anteil der mobilen Internetnutzer bei 84%.",
  },
  {
    icon: icon4,
    step: "04",
    heading: "Technische Qualität",
    description: "Modernste Technologien, hohe Sicherheitsstandards und eine stabile Basis für langfristiges Wachstum.",
  },
];
const works = [
  {
    id: "w1",
    image: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b?w=1200&q=80&auto=format&fit=crop",
    title: "Individuelles CRM für Inkasso-Agentur",
    desc: "„Unser gesamter Forderungs-Workflow wurde automatisiert. Wir sparen jetzt über 20 Stunden pro Woche und verfolgen jede Rechnung in Echtzeit.“",
    tags: ["CRM Entwicklung", "Automatisierung"],
    href: "#",
  },
  {
    id: "w2",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80&auto=format&fit=crop",
    title: "Modernes Web-Portal für B2B Kunden",
    desc: "„Das neue Portal hat unsere Conversion-Rate verdoppelt und unseren Kunden ein professionelles digitales Erlebnis gegeben.“",
    tags: ["Web Entwicklung", "UI/UX"],
    href: "#",
  },
  {
    id: "w3",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80&auto=format&fit=crop",
    title: "Automatisiertes Forderungs-Tracking System",
    desc: "„Wir können jetzt tausende Rechnungen verfolgen, Erinnerungen automatisch senden und Reports in Sekunden erstellen.“",
    tags: ["CRM", "Workflow Automatisierung"],
    href: "#",
  },
  {
    id: "w4",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&q=80&auto=format&fit=crop",
    title: "Landing Page & Marketing Website",
    desc: "„Unsere neue Website spiegelt endlich die Qualität unserer Dienstleistungen wider und generiert täglich neue Leads.“",
    tags: ["Web Design", "Performance"],
    href: "#",
  },
];


// usage
// <MyWorksCarousel title="My Works" subtitle="..." items={works} />

  return (

    <>
     <SEO
        title="Conversion-optimiertes Webdesign | UNEVA "
        description="Mehr Anfragen, mehr Umsatz: Conversionstarkes Webdesign mit klarer Struktur, starken CTAs und überzeugendem Design."
        canonical="https://uneva.de/webdesign-agentur-bremen"
      />
       <div className="relative min-h-screen">
      {/* Navbar on top of hero */}
      <Navbar />
      <HeroSection />
      <Offers />
      <Attention title="Worauf wir achten" cards={cardData} />
      <FreeConsultation />
      <Principle />
      <WhoItsForCards/>
      <Portfolio items={works}/>
      <Hook/>
      <WhySeo />
      <Footer/>
    </div>
    </>
   
  );
};

export default WebDesign;
